<div class="right-side-wrapper" id="tab-view">
    <div class="tab-area-wrapper tab-entities-wrapper">
        <div class="filter">
            <div *ngIf="trlConfig?.tenant!=='TRL' && trlConfig?.tenant!=='DMK'" class="filter-gap">
                <div>
                    <mat-form-field class="field" appearance="outline">
                        <mat-label>Page Size</mat-label>
                        <mat-select [formControl]="pageSize" panelClass="multiSelectPanel">
                            <mat-option *ngFor="let item of pageSizeLimit" [value]="item" (click)="onPageLimitChange()">
                                {{item}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field class="field" appearance="outline">
                        <mat-label>Period Filter</mat-label>
                        <mat-select [formControl]="period" panelClass="multiSelectPanel">
                            <mat-option *ngFor="let item of periodList" [value]="item"
                                (click)="onPeriodFilterChange(attributeList)">
                                {{item.name | titlecase}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <button mat-raised-button color="primary" (click)="exportData()" *ngIf="tabData?.category=='patient'"
                class="export-button">Export<img src="../../../../assets/images/file-download-icon.svg" alt="Export"
                    class="ml-2"></button>
        </div>

        <mat-tab-group (selectedTabChange)="tabChanged($event)" [selectedIndex]="intialTabIndex" *ngIf="tabData">
            <mat-tab *ngIf="tabData?.type == 1 && trlConfig?.tenant!=='TRL'">
                <ng-template mat-tab-label>
                    <span class="tab-icon"><i class="fa fa-truck fa-lg" aria-hidden="true"></i></span>
                    Vehicle Statistics
                </ng-template>
                <div class="com-pro">
                    <div class="tile">
                        <div class="tile-title">
                            <h5 class="l-space-between-containers"><strong>Driving Behaviour</strong></h5>
                        </div>
                        <div class="tile-chart-area" *ngIf="drivingBehaviour?.length">
                            <app-plotly-bar [barData]="drivingBehaviour"></app-plotly-bar>
                        </div>
                    </div>
                    <div class="tile">
                        <div class="tile-title">
                            <h5 class="l-space-between-containers"><strong>Vehicle Utilization</strong></h5>
                        </div>
                        <div class="tile-chart-area" *ngIf="entityUtilization?.length">
                            <app-plotly-donut [donutData]="entityUtilization"></app-plotly-donut>
                        </div>
                    </div>
                    <div class="tile">
                        <div class="tile-title">
                            <h5 class="l-space-between-containers"><strong>Vehicle Health</strong></h5>
                        </div>
                        <div class="grid-3">
                            <div class="tab-health-table-wrapper col-spacing">
                                <div class="set-col">
                                    <span><strong>Issue Type</strong></span><br>
                                    <span><img src="../../assets/images/engine.svg" class="w-20" alt="engine"
                                            title="Engine">&nbsp;Engine</span>
                                    <br>
                                    <span><img src="../../assets/images/coolant.svg" class="w-20" alt="coolant"
                                            title="Coolant">&nbsp;Coolant</span>
                                    <br>
                                    <span><img src="../../assets/images/batterynew.svg" class="w-20" alt="battery"
                                            title="Battery">&nbsp;Battery</span>
                                </div>
                                <div class="set-col">
                                    <span><strong>Status</strong></span><br>
                                    <span class="cg">Good</span>
                                    <br><span class="cr">Inspection required</span><br>
                                    <span class="cr">Issue found</span>
                                </div>
                                <div class="set-col">
                                    <span><strong>Error Code</strong></span><br>
                                    <span class="cr">{{tabData?.entityHealthDetails?.issueType[0].engine?.errorCode
                                        ? tabData?.entityHealthDetails?.issueType[0].engine?.errorCode :
                                        'NA'}}</span>
                                    <br><span class="cg">{{tabData?.entityHealthDetails.issueType[1].coolent?.errorCode
                                        ? tabData.entityHealthDetails.issueType[1].coolent?.errorCode:
                                        'NA'}}</span><br>
                                    <span class="cg">{{tabData?.entityHealthDetails.issueType[2].battery?.errorCode
                                        ? tabData.entityHealthDetails.issueType[2].battery?.errorCode:
                                        'NA'}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tile">
                        <div class="tile-title">
                            <h5 class="l-space-between-containers"><strong>Active Alerts - 22</strong></h5>
                        </div>
                        <div class="tile-chart-area" *ngIf="activeAlerts?.length">
                            <app-plotly-bar [barData]="activeAlerts"></app-plotly-bar>
                        </div>
                    </div>
                </div>
            </mat-tab>
            <mat-tab
                *ngIf="(tabData?.type == 1 && trlConfig?.tenant!=='TRL')  && (tabData?.type == 2 && (trlConfig?.tenant!=='DMK' || tabData?.category !== 'monotainer'))">
                <ng-template mat-tab-label>
                    <span class="tab-icon"><i class="fa fa-play fa-lg" aria-hidden="true"></i></span>
                    History PlayBack
                </ng-template>
                <div class="com-pro">
                    <div class="tile" *ngIf="tabIndex===1 && masterMapData?.length">
                        <app-leaflet-map pageType="profile" [mapData]="masterMapData"></app-leaflet-map>
                    </div>
                    <div class="tile">
                        <div class="tile-title">
                            <h5 class="l-space-between-containers"><strong>KM/L</strong></h5>
                        </div>
                        <div class="tile-chart-area" *ngIf="mileage?.length">
                            <app-plotly-line [lineData]="mileage"></app-plotly-line>
                        </div>
                    </div>
                    <div class="tile">
                        <div class="tile-title">
                            <h5 class="l-space-between-containers"><strong>AVG SPEED</strong></h5>
                        </div>
                        <div class="tile-chart-area" *ngIf="speed?.length">
                            <app-plotly-line [lineData]="speed"></app-plotly-line>
                        </div>
                    </div>
                    <div class="tile">
                        <div class="tile-title">
                            <h5 class="l-space-between-containers"><strong>FUEL CONSUMED</strong></h5>
                        </div>
                        <div class="tile-chart-area" *ngIf="fuel?.length">
                            <app-plotly-line [lineData]="fuel"></app-plotly-line>
                        </div>
                    </div>
                </div>
            </mat-tab>
            <mat-tab
                *ngIf="(tabData?.type == 1 && trlConfig?.tenant!=='TRL')  && (tabData?.type == 2 && (trlConfig?.tenant!=='DMK' || tabData?.category !== 'monotainer'))">
                <ng-template mat-tab-label>
                    <span class="tab-icon"><i class="fa fa-play fa-lg" aria-hidden="true"></i></span>
                    Insights
                </ng-template>
                <mat-tab-group (selectedTabChange)="insightsTabChanged($event)">
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <span class="tab-icon"><i class="fa fa-truck fa-lg" aria-hidden="true"></i></span>
                            Vehicle Statistics
                        </ng-template>
                        <div class="w-100" *ngIf="insightTabIndex===0">
                            <app-vehicle-insight [tabData]="{entityId: tabData?._id , attribute:'distance'}">
                            </app-vehicle-insight>
                        </div>
                    </mat-tab>
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <span class="tab-icon"><i class="fa fa-truck fa-lg" aria-hidden="true"></i></span>
                            Idiling Fuel
                        </ng-template>
                        <div class="w-100" *ngIf="insightTabIndex===1">
                            <app-vehicle-insight [tabData]="{entityId: tabData?._id , attribute:'idling'}">
                            </app-vehicle-insight>
                        </div>
                    </mat-tab>
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <span class="tab-icon"><i class="fa fa-truck fa-lg" aria-hidden="true"></i></span>
                            Distance chart
                        </ng-template>
                        <div class="w-100" *ngIf="insightTabIndex===2">
                            <app-vehicle-insight [tabData]="{entityId: tabData?._id , attribute:'distance'}">
                            </app-vehicle-insight>
                        </div>
                    </mat-tab>
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <span class="tab-icon"><i class="fa fa-truck fa-lg" aria-hidden="true"></i></span>
                            Ride status
                        </ng-template>
                        <div class="w-100" *ngIf="insightTabIndex===3">
                            <app-vehicle-insight [tabData]="{entityId: tabData?._id}">
                            </app-vehicle-insight>
                        </div>

                    </mat-tab>
                </mat-tab-group>
            </mat-tab>
            <mat-tab *ngIf="tabData?.type == 3 && trlConfig?.tenant!=='TRL' && trlConfig?.tenant!=='DMK'">
                <ng-template mat-tab-label>
                    Vitals History
                </ng-template>

            </mat-tab>
            <mat-tab *ngIf="tabData?.type == 2 && tabData?.category == 'monotainer'">
                <ng-template mat-tab-label>
                    Monotainer History
                </ng-template>
            </mat-tab>
            <mat-tab *ngIf="tabData?.type === 1 && trlConfig?.tenant==='TRL'">
                <ng-template mat-tab-label>
                    RUL Statistics
                </ng-template>
                <app-rul-statistics *ngIf="tabIndex === 0" [entityData]="tabData"></app-rul-statistics>
            </mat-tab>
            <mat-tab *ngIf="tabData?.type === 2 && trlConfig?.tenant==='DMK'">
                <ng-template mat-tab-label>
                    Appliance History
                </ng-template>
                <app-telematics-histroy [entityData]="tabData"></app-telematics-histroy>
            </mat-tab>
            <mat-tab
                *ngIf="(tabData?.type === 1 && trlConfig?.tenant==='TRL') || (tabData?.type === 2 && trlConfig?.tenant==='DMK')">
                <ng-template mat-tab-label>
                    {{getTabTitle(trlConfig?.tenant)}}
                </ng-template>
                <app-attributes-charts [entityData]="tabData">
                </app-attributes-charts>
            </mat-tab>
            <mat-tab *ngFor="let tabType of tabStructure?.tabs">
                <ng-template mat-tab-label>
                    {{trlConfig?.tenant==='TRL'?'Telematics Statistics':tabType?.title}}
                </ng-template>
                <div *ngIf="isloader" class="h-100 w-100 padt-5">
                    <mat-progress-bar [mode]="'indeterminate'">
                    </mat-progress-bar>
                </div>
                <div *ngIf="trlConfig?.tenant==='TRL'" class="attr-header-wrapper">
                    <div class="date"><span class="date-label">Updated on</span>&nbsp;&nbsp;{{apiHitTime|
                        date:'dd-MMM-y hh:mm:ss
                        aaa':'en-US'}}</div>
                    <div class="filter-drop-down dropdown att-filter align-end rt-filter">
                        <mat-form-field appearance="outline">
                            <mat-select [formControl]="period" panelClass="multiSelectPanel"
                                placeholder="Period Filter">
                                <mat-option *ngFor="let item of periodList" [value]="item"
                                    (click)="onPeriodFilterChange(attributeList)">
                                    {{item.name | titlecase}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div>
                    <mat-tab-group (selectedTabChange)="tabChanged($event)" class="vehicle-details-wrapper"
                        *ngIf="attributeDataList?.length && tabType?.subtabs">
                        <mat-tab [label]="subTab?.title | titlecase" *ngFor="let subTab of tabType?.subtabs">
                            <div *ngFor="let attr of subTab?.attributes">
                                <div *ngFor="let tab of attributeDataList">
                                    <div class="make-responsive-entitylist-shadow w-100 d-grid uni-entitylist"
                                        *ngIf="tab?.attributeData[0]?.tabTitle === attr?.name">
                                        <div class="attr-header-wrapper">
                                            <div class="vehicle-profile-header">
                                                <span
                                                    class="attr-header">{{tab?.attributeData[0]?.tabTitle+(attr?.uom?"("+attr?.uom+")":"")|
                                                    titlecase}} </span> - &nbsp;
                                                <mat-checkbox class="example-margin"
                                                    [checked]="tab?.statisticsData?.showTrend" *ngIf="showTrend"
                                                    (change)="showHistory(tab?.attributeData[0]?.tabTitle, $event,'trend')">
                                                    Show Trend</mat-checkbox>
                                                <span *ngIf="tab?.statisticsData?.absoluteTrendType ">
                                                    &nbsp; Absolute : </span>
                                                <span *ngIf="tab?.statisticsData?.absoluteTrendType">
                                                    <i class="fa fa-arrow-up"
                                                        *ngIf="tab?.statisticsData?.absoluteTrendType == 'positive'"></i>
                                                    <i class="fa fa-arrow-down"
                                                        *ngIf="tab?.statisticsData?.absoluteTrendType == 'negative'"></i>
                                                    <i class="fa-solid fa-hyphen"
                                                        *ngIf="tab?.statisticsData?.rateTrendType == 'neutral'">&#8776;</i>
                                                    {{tab?.statisticsData?.absoluteTrendPercentage}}&nbsp;
                                                </span>
                                                <span *ngIf="tab?.statisticsData?.rateTrendType">
                                                    &nbsp; Rate : </span>
                                                <span *ngIf="tab?.statisticsData?.rateTrendType">
                                                    <i class="fa fa-arrow-up"
                                                        *ngIf="tab?.statisticsData?.rateTrendType == 'positive'"></i>
                                                    <i class="fa fa-arrow-down"
                                                        *ngIf="tab?.statisticsData?.rateTrendType == 'negative'"></i>
                                                    <i class="fa-solid fa-hyphen"
                                                        *ngIf="tab?.statisticsData?.rateTrendType == 'neutral'">&#8776;</i>
                                                    {{tab?.statisticsData?.rateTrendPercentage}}&nbsp;
                                                </span>
                                                <mat-checkbox class="example-margin"
                                                    *ngIf="showTrend && tab?.statisticsData?.showTrend"
                                                    [checked]="tab?.statisticsData?.showHistory"
                                                    (change)="showHistory(tab?.attributeData[0]?.tabTitle, $event, 'history')">
                                                    Show History</mat-checkbox>
                                            </div>
                                            <div> <span class="windowTime"
                                                    *ngIf="tab?.statisticsData?.absoluteLastProcessedTimestamp || tab?.statisticsData?.rateLastProcessedTimestamp">
                                                    As of
                                                    {{(tab?.statisticsData?.rateLastProcessedTimestamp ?
                                                    tab?.statisticsData?.rateLastProcessedTimestamp :
                                                    tab?.statisticsData?.absoluteLastProcessedTimestamp) |
                                                    date:'medium'}}
                                                    based on data from
                                                    {{(tab?.statisticsData?.absoluteWindowSize ?
                                                    tab?.statisticsData?.absoluteWindowSize :
                                                    tab?.statisticsData?.rateWindowSize) | date:'medium'}}
                                                </span></div>
                                        </div>
                                        <div class="chart-resp">
                                            <div>
                                                <app-plotly-line [lineData]="tab?.attributeData"></app-plotly-line>
                                            </div>
                                            <div class="d-grid h-100 p-3 gp-20 chart-tabs-side ">

                                                <div *ngIf="tabData?.category != 'patient'"
                                                    class="d-flex justify-content-center">
                                                    <div>Current Value</div>
                                                    <h4 class="title value-color">{{tab?.currentValue}}</h4>

                                                </div>
                                                <div class="d-flex justify-content-center"
                                                    *ngIf="tabData?.category != 'patient'&&trlConfig?.tenant!=='TRL'">
                                                    <div>Window average</div>
                                                    <h4 class="title value-color">{{tab?.windowAverage}}</h4>
                                                </div>

                                                <div class="d-flex justify-content-center h-100 "
                                                    *ngIf="tabData?.category == 'patient'&&trlConfig?.tenant!=='TRL'">
                                                    <div>Invalid Points</div>
                                                    <h4 class="title value-color">
                                                        {{tab?.statisticsData.invalidPointCount}}</h4>
                                                </div>
                                                <div class="d-flex justify-content-center h-100 "
                                                    *ngIf="trlConfig?.tenant!=='TRL'">
                                                    <div>Upper Alert threshold</div>
                                                    <h4 class="title value-color">
                                                        {{tab?.statisticsData?.upperAlertThreshold?
                                                        tab?.statisticsData?.upperAlertThreshold : 'NA'}}</h4>

                                                </div>
                                                <div class="d-flex justify-content-center h-100 "
                                                    *ngIf="trlConfig?.tenant!=='TRL'">
                                                    <div>Lower Alert threshold</div>
                                                    <h4 class="title value-color">
                                                        {{tab?.statisticsData?.lowerAlertThreshold?
                                                        tab?.statisticsData?.lowerAlertThreshold: 'NA'}}</h4>

                                                </div>
                                                <div class="d-flex justify-content-center h-100 "
                                                    *ngIf="trlConfig?.tenant!=='TRL'">
                                                    <div>Mean</div>
                                                    <h4 class="title value-color">{{tab?.statisticsData.mean}}</h4>

                                                </div>
                                                <div class="d-flex justify-content-center h-100"
                                                    *ngIf="trlConfig?.tenant==='TRL'">
                                                    <div>Computed Mean</div>
                                                    <h4 class="title value-color">{{tab?.statisticsData.mean}}</h4>
                                                </div>
                                                <div class="d-flex justify-content-center h-100"
                                                    *ngIf="trlConfig?.tenant==='TRL'">
                                                    <div>Upper Threshold</div>
                                                    <h4 class="title value-color">
                                                        {{tab?.statisticsData?.upperAlertThreshold?
                                                        tab?.statisticsData?.upperAlertThreshold : 'NA'}}</h4>
                                                </div>
                                                <div class="d-flex justify-content-center h-100"
                                                    *ngIf="trlConfig?.tenant==='TRL'">
                                                    <div>Lower Threshold</div>
                                                    <h4 class="title value-color">
                                                        {{tab?.statisticsData?.lowerAlertThreshold?
                                                        tab?.statisticsData?.lowerAlertThreshold: 'NA'}}</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </mat-tab>
                    </mat-tab-group>
                </div>
                <div *ngIf="attributeDataList?.length && !tabType?.subtabs">
                    <div *ngFor="let attr of tabType?.attributes">
                        <div *ngFor="let tab of attributeDataList, let i = index">
                            <div class="make-responsive-entitylist-shadow w-100 d-grid uni-entitylist"
                                *ngIf="tab?.attributeData[0]?.tabTitle === attr?.name">
                                <div class="vehicle-profile-header">
                                    <span
                                        class="attr-header">{{tab?.attributeData[0]?.tabTitle+(attr?.uom?"("+attr?.uom+")":"")|titlecase}}
                                    </span> - &nbsp;
                                    <mat-checkbox class="example-margin" [checked]="tab?.statisticsData?.showTrend"
                                        *ngIf="showTrend"
                                        (change)="showHistory(tab?.attributeData[0]?.tabTitle, $event, 'trend')">
                                        Show Trend</mat-checkbox>
                                    <span *ngIf="tab?.statisticsData?.absoluteTrendType ">
                                        &nbsp; Absolute : </span>
                                    <span *ngIf="tab?.statisticsData?.absoluteTrendType">
                                        <i class="fa fa-arrow-up"
                                            *ngIf="tab?.statisticsData?.absoluteTrendType == 'positive'"></i>
                                        <i class="fa fa-arrow-down"
                                            *ngIf="tab?.statisticsData?.absoluteTrendType == 'negative'"></i>
                                        <i class="fa-solid fa-hyphen"
                                            *ngIf="tab?.statisticsData?.rateTrendType == 'neutral'">&#8776;</i>
                                        {{tab?.statisticsData?.absoluteTrendPercentage}}&nbsp;
                                    </span>
                                    <span *ngIf="tab?.statisticsData?.rateTrendType">
                                        &nbsp; Rate : </span>
                                    <span *ngIf="tab?.statisticsData?.rateTrendType">
                                        <i class="fa fa-arrow-up"
                                            *ngIf="tab?.statisticsData?.rateTrendType == 'positive'"></i>
                                        <i class="fa fa-arrow-down"
                                            *ngIf="tab?.statisticsData?.rateTrendType == 'negative'"></i>
                                        <i class="fa-solid fa-hyphen"
                                            *ngIf="tab?.statisticsData?.rateTrendType == 'neutral'">&#8776;</i>
                                        {{tab?.statisticsData?.rateTrendPercentage}}&nbsp;
                                    </span>
                                    <mat-checkbox class="example-margin"
                                        *ngIf="showTrend && tab?.statisticsData?.showTrend"
                                        [checked]="tab?.statisticsData?.showHistory"
                                        (change)="showHistory(tab?.attributeData[0]?.tabTitle, $event, 'history')">
                                        Show History</mat-checkbox>
                                    <div>
                                        <span class="windowTime"
                                            *ngIf="tab?.statisticsData?.absoluteLastProcessedTimestamp || tab?.statisticsData?.rateLastProcessedTimestamp">
                                            As of
                                            {{(tab?.statisticsData?.rateLastProcessedTimestamp ?
                                            tab?.statisticsData?.rateLastProcessedTimestamp :
                                            tab?.statisticsData?.absoluteLastProcessedTimestamp) | date:'medium'}}
                                            based on data from
                                            {{(tab?.statisticsData?.absoluteWindowSize ?
                                            tab?.statisticsData?.absoluteWindowSize :
                                            tab?.statisticsData?.rateWindowSize) | date:'medium'}}
                                        </span>
                                    </div>
                                    <div class="chart-resp">
                                        <div>
                                            <app-plotly-line [lineData]="tab?.attributeData"></app-plotly-line>
                                        </div>
                                        <div class="d-grid h-100 p-3 gp-20 chart-tabs-side">

                                            <div class="d-flex justify-content-center"
                                                *ngIf="tabData?.category != 'patient'">
                                                <div>Current Value</div>
                                                <h4 class="title value-color">{{tab?.currentValue}}</h4>

                                            </div>
                                            <div class="d-flex justify-content-center"
                                                *ngIf="tabData?.category != 'patient'&&trlConfig?.tenant!=='TRL'">
                                                <div>Window average</div>
                                                <h4 class="title value-color">{{tab?.windowAverage}}</h4>

                                            </div>


                                            <div class="d-flex justify-content-center h-100 "
                                                *ngIf="tabData?.category == 'patient'&&trlConfig?.tenant!=='TRL'">
                                                <div>Invalid Points</div>
                                                <h4 class="title value-color">
                                                    {{tab?.statisticsData.invalidPointCount}}
                                                </h4>
                                            </div>
                                            <div class="d-flex justify-content-center h-100 "
                                                *ngIf="trlConfig?.tenant!=='TRL'">
                                                <div>Upper Alert threshold</div>
                                                <h4 class="title value-color">
                                                    {{tab?.statisticsData?.upperAlertThreshold?
                                                    tab?.statisticsData?.upperAlertThreshold : 'No Data'}}</h4>

                                            </div>
                                            <div class="d-flex justify-content-center h-100 "
                                                *ngIf="trlConfig?.tenant!=='TRL'">
                                                <div>Lower Alert threshold</div>
                                                <h4 class="title value-color">
                                                    {{tab?.statisticsData?.lowerAlertThreshold?
                                                    tab?.statisticsData?.lowerAlertThreshold: 'No Data'}}</h4>

                                            </div>
                                            <div class="d-flex justify-content-center h-100"
                                                *ngIf="trlConfig?.tenant!=='TRL'">
                                                <div>Mean</div>
                                                <h4 class="title value-color">{{tab?.statisticsData.mean}}</h4>

                                            </div>
                                            <div class="d-flex justify-content-center h-100"
                                                *ngIf="trlConfig?.tenant==='TRL'">
                                                <div>Computed Mean</div>
                                                <h4 class="title value-color">{{tab?.statisticsData.mean}}</h4>
                                            </div>
                                            <div class="d-flex justify-content-center h-100"
                                                *ngIf="trlConfig?.tenant==='TRL'">
                                                <div>Upper Threshold</div>
                                                <h4 class="title value-color">
                                                    {{tab?.statisticsData?.upperAlertThreshold?
                                                    tab?.statisticsData?.upperAlertThreshold : 'NA'}}</h4>
                                            </div>
                                            <div class="d-flex justify-content-center h-100"
                                                *ngIf="trlConfig?.tenant==='TRL'">
                                                <div>Lower Threshold</div>
                                                <h4 class="title value-color">
                                                    {{tab?.statisticsData?.lowerAlertThreshold?
                                                    tab?.statisticsData?.lowerAlertThreshold: 'NA'}}</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <p *ngIf="isloader || isError || !attributeDataList?.length">No Attributes available</p>
                </div>
            </mat-tab>
            <mat-tab *ngIf="tabData?.type === 1 && trlConfig?.tenant==='TRL'">
                <ng-template mat-tab-label>
                    Telematics History
                </ng-template>
                <app-telematics-histroy *ngIf="tabIndex === 2" [entityData]="tabData"></app-telematics-histroy>
            </mat-tab>
            <mat-tab *ngIf="service.rbacManagement('entities_Alerts')">
                <ng-template mat-tab-label>
                    Alerts
                </ng-template>
                <app-entity-alerts [entityId]="tabData?._id"></app-entity-alerts>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>